import { KnownCookies } from 'common-types';

export const CCPA_OPT_OUT_VALUE = '1';
export const CCPA_OPT_IN_VALUE = '0';

export type PrivacyConsentState = 'opt-in' | 'opt-out' | 'unknown';

export interface PrivacyConsentModel {
  state: PrivacyConsentState;
}

export function createPrivacyConsentModel(
  ccpaCookie: KnownCookies['ccpa'],
  secGPCHeader?: 'false' | 'true' | string,
): PrivacyConsentModel {
  let state: PrivacyConsentState;
  if (ccpaCookie == CCPA_OPT_IN_VALUE) {
    state = 'opt-in';
  } else if (
    isSecHeaderTruthy(secGPCHeader) ||
    ccpaCookie == CCPA_OPT_OUT_VALUE
  ) {
    state = 'opt-out';
  } else {
    state = 'unknown';
  }

  console.log('Initializing privacy consent model', {
    ccpaCookie,
    secGPCHeader,
    state,
  });

  return {
    state,
  };
}

export function shouldShowPrivacyBanner(model: PrivacyConsentModel): boolean {
  return model.state === 'unknown';
}

export function shouldLoadThirdPartyScripts(
  model: PrivacyConsentModel,
): boolean {
  return model.state === 'opt-in';
}

export function shouldShowAds(model: PrivacyConsentModel): boolean {
  return model.state === 'opt-in';
}

function isSecHeaderTruthy(value: any): boolean {
  if (value === 'true' || value === '1') {
    return true;
  } else {
    return false;
  }
}
